<template>
  <!-- 公司收藏 -->
  <div class="box">
    <div
      class="container"
      v-for="(item, index) in listArr1"
      :key="index"
      @click="handelSkip(item)"
    >
      <div class="logoName">
        <!-- 公司logo -->
        <div class="logo">
          <img :src="item.logoImg" alt="" />
        </div>
        <!-- 公司名 -->
        <div class="corporation-name">{{ item.name }}</div>
        <!-- 收藏icon -->
        <div class="Collect-icon">
          <div class="firm-clickable" @click.stop="handelCollectFirm(item)"></div>
        </div>
      </div>
      <p class="earnings data-p">行业：{{ item.industryName }}</p>
      <p class="address data-p">地址：{{ item.companyAddress }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listArr1: {},
    listarr: {},
  },
  created() {},
  methods: {
    // 点击企业名称 跳转公司详情
    handelSkip(item) {
      console.log(item, "111111");
      this.$router.push({
        path: "/ComDetails",
        query: { key: item.companyId, select: 1 },
      });
    },
    // 点击收藏 /取消收藏
    handelCollectFirm(item) {
      this.$emit("handelCollectFirm", item);
    },
  },
};
</script>

<style scoped lang="less">
.box {
  min-width: 800px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .container:hover {
    box-shadow: 0px 0px 6px 1px rgba(50, 145, 248, 0.8);
  }
  .container {
    width: 390px;
    min-height: 130px;
    box-sizing: border-box;
    margin-left: 15px;
    margin-top: 15px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    // 公司logo 公司名 公司地址 收藏icon
    .logoName {
      width: 350px;
      height: 50px;
      margin: 0 auto;
      margin-top: 10px;
      display: flex;
      .logo {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .corporation-name:hover {
        color: #f8b3b3;
      }
      .corporation-name {
        max-width: 250px;
        line-height: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333300;
        font-weight: 400;
        margin-left: 10px;
      }
      .Collect-icon {
        flex: 1;
        height: 20px;
        margin: auto;
        display: flex;
        justify-content: flex-end;
        div {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../../assets/imgs/shoucang@3x.svg");
          background-size: 100% 100%;
        }
      }
    }
    // 行业地址
    .data-p {
      width: 350px;
      height: 17px;
      margin: 0 auto;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333300;
      font-weight: 400;
    }
    .earnings {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .address {
      margin-bottom: 15px;
    }
  }
  .container:nth-child(2n + 1) {
    margin-left: 0px;
  }
}
</style>
